import * as React from 'react';

import { cn, EntityIcon } from '@klareospace/pharos-lib-web-utils';
import type { EntityIconProps } from '@klareospace/pharos-lib-web-utils';

// ─── Types ────────────────────────────────────────────────────────────────────

interface PersonIconProps {
  className?: string;
  /** Full name to compute initials from. */
  name: string;
  /** Icon size variant (defaults to "sm", the settings-table look). */
  size?: EntityIconProps['size'];
}

// ─── Constants ────────────────────────────────────────────────────────────────

// EntityIcon's default font-size scale is smaller than the legacy person-initials look at these
// sizes; restore the original text size. "xs" is intentionally left unmapped — tasks-section
// converges on EntityIcon's canonical xs text size rather than a hand-rolled override.
const TEXT_SIZE_OVERRIDES: Partial<Record<NonNullable<EntityIconProps['size']>, string>> = {
  lg: 'text-lg',
  sm: 'text-sm',
  xl: 'text-2xl',
};

// ─── Component ────────────────────────────────────────────────────────────────

/** Circular, primary-toned initials icon for people (drivers, users) across settings tables. */
export function PersonIcon({ className, name, size = 'sm' }: PersonIconProps): React.JSX.Element {
  return (
    <EntityIcon
      alt={name}
      className={cn(TEXT_SIZE_OVERRIDES[size], className)}
      shape="circle"
      size={size}
      tone="primary"
    />
  );
}
